export { default as PatientRouteService } from './PatientRouteService';
export { default as PatientService } from './PatientService';
export { default as SalesOrderService } from './SalesOrderService';
export { default as SalesOrderRouteService } from './SalesOrderRouteService';
export { default as TemplateService } from './TemplateService';
export { default as TemplateRouteService } from './TemplateRouteService';
export { default as LocalPatientRouteService } from './LocalPatientRouteService';
export { default as LocalPatientService } from './LocalPatientService';